module.exports = "/images/info_purple_btn.png?319579e70f9e690fc83a4a91b9168771";